"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortenText = void 0;
const shortenText = (str) => {
    var _a;
    const name = str;
    const nameSplit = name.split(' ');
    const nameShort = nameSplit.length > 1 ? nameSplit[0] + ' ' + ((_a = nameSplit[1]) === null || _a === void 0 ? void 0 : _a.substring(0, 1)) + '.' : nameSplit[0];
    return str.length < 12 ? str : nameShort;
};
exports.shortenText = shortenText;
